// extracted by mini-css-extract-plugin
module.exports = {"containerMobileBankCards":"styles_containerMobileBankCards__LtxwH"};